import { render, staticRenderFns } from "./altinn-tax-invoice-previews.vue?vue&type=template&id=6f94c73c&scoped=true&"
import script from "./altinn-tax-invoice-previews.vue?vue&type=script&lang=ts&"
export * from "./altinn-tax-invoice-previews.vue?vue&type=script&lang=ts&"
import style0 from "./altinn-tax-invoice-previews.vue?vue&type=style&index=0&id=6f94c73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f94c73c",
  null
  
)

export default component.exports